import styled from 'styled-components'
import { font, bp } from 'lib/core/resources/helpers/styled'

export const QuestionWrapper = styled.div`
  color: ${props => props.theme.palette.primary.alphaDark};
  min-height: 55vh;
  ${bp('sm')`
    margin-bottom: 25px;
  `}

  .textareaExtra {
    display: block;
    width: 100%;
    margin-top: 20px;
    min-height: 80px;
  }

  h3 {
    font: ${font('default', 'medium', '35px/1.5')};
    margin: 0;
    ${bp('sm')`
      font: ${font('default', 'medium', '25px/1.2')};
    `}
  }

  .question {
    &__heading {
      margin-bottom: 25px;

      p,
      em {
        font-size: 18px;
        ${bp('sm')`
          font-size: 16px;
        `}
      }
    }

    &__info {
      font: ${font('default', 'normal', '18px/1.2')};
      font-style: oblique;
      ${bp('sm')`
        font: ${font('default', 'normal', '16px/1')};
      `}
    }

    &__options-wrapper {
      &.columns-2 {
        columns: 2 auto;

        > label {
          list-style-position: inside;
          page-break-inside: avoid;
          break-inside: avoid;
        }
      }
    }
  }
`
